function toggleItemDelete(table) {
    const card = $(table).closest('.card');
    const hasChecked = $(table).find('tbody input[type=checkbox]:checked').length > 0;

    card.find('.itemDelete').toggle(hasChecked);
}

// 초기 숨김 + 초기 상태 반영
$('.card .itemDelete').hide();
$('.card table').each(function () {
    toggleItemDelete(this);
});

// tbody 체크박스 변경 시
$(document).on('change', '.card tbody input[type=checkbox]', function () {
    const table = $(this).closest('table');
    toggleItemDelete(table);
});

// thead 전체선택 체크박스
$(document).on('change', '.card thead th:first-child input[type=checkbox]', function () {
    const table = $(this).closest('table');
    table.find('tbody tr td:first-child input[type=checkbox]').prop('checked', this.checked);
    toggleItemDelete(table);
});